import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

//css
import * as styles from "../../include/css/css-components/header/Header.module.css";
import { navigate } from "gatsby";
import ChatIcon from "./chatIcon";
import useNCNDACheck from "./customHooks/useNCNDACheck";
import NCNDAModal from "../models/ncndaModal";

const CommonHeader = (props) => {
  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };
  const [mimic, setMimic] = useState(
    typeof window !== "undefined" && localStorage.getItem("mimictoken") ? true : false,
  );

  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute("src", "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit");
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
    if (typeof window !== "undefined" && localStorage.getItem("mimictoken")) {
      setMimic(true);
    }
  }, []);

  return (
    <>
      {!isMobile ? (
        mimic ? (
          <>
            <div class={`${styles.headerTextWrapper} text-center d-flex align-items-center`}>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <strong>Currently Logged In as</strong>{" "}
                    {typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"))?.name01}.{" "}
                    <a
                      href=""
                      target="_blank"
                      onClick={(e) => {
                        e.preventDefault();
                        localStorage.removeItem("mimictoken");
                        localStorage.removeItem("mimicmember");
                        window.location.reload();
                      }}
                    >
                      Click here
                    </a>{" "}
                    to login back to your account.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${styles.headerTopContainer} d-flex align-items-center new-brand-common-header d-none d-xl-block`}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 d-flex align-items-center position-relative">
                    <>
                      <div
                        className={
                          typeof window !== "undefined" && localStorage.getItem("token")
                            ? `${styles.htcTextBox}`
                            : `${styles.htcTextBox}`
                        }
                      >
                        <strong>$5.2B Global Marketplace</strong> for Asset Recovery & Surplus Inventory
                      </div>

                      <div className="htc-nav  ms-auto d-none d-xl-block">
                        <ul
                          className="htc-nav-list text-capitalize d-flex align-items-center"
                          style={{ marginRight: "13rem" }}
                        >
                          {typeof window !== "undefined" && (
                            <>
                              {localStorage.getItem("member") && (
                                <li class="htc-nav-item position-relative">
                                  <a
                                    href="javascript:void(0)"
                                    class={`${styles.htcNavLink} htc-nav-link add-to-cart`}
                                    data-bs-toggle="modal"
                                    data-bs-target="#chatCollapse"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      props?.toggleHelp();
                                    }}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M9.09009 9.00008C9.32519 8.33175 9.78924 7.76819 10.4 7.40921C11.0108 7.05024 11.729 6.91902 12.4273 7.03879C13.1255 7.15857 13.7589 7.52161 14.2152 8.06361C14.6714 8.60561 14.9211 9.2916 14.9201 10.0001C14.9201 12.0001 11.9201 13.0001 11.9201 13.0001"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12 17H12.01"
                                        stroke="white"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    Help
                                  </a>
                                </li>
                              )}
                              {localStorage.getItem("member") &&
                                JSON.parse(localStorage.getItem("member")).sec_list != 100103 && (
                                  <>
                                    {window.location.pathname === "/chats" || window.location.pathname === "/chats/" ? (
                                      <li className={` htc-nav-item`}>
                                        <a
                                          href="javascript:void(0)"
                                          className={` htc-nav-link`}
                                          data-bs-toggle="modal"
                                          data-bs-target="#chatCollapse"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            //this.setState({ chatNotification: false });
                                            navigate("/chats");
                                          }}
                                        >
                                          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                              d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            ></path>
                                          </svg>
                                          Messages
                                          {props?.unReadChatCount > 0 ? (
                                            <span class="cart-numbers chat-unread">{props?.unReadChatCount}</span>
                                          ) : (
                                            ""
                                          )}
                                        </a>
                                      </li>
                                    ) : (
                                      <ChatIcon unReadChatCount={props?.unReadChatCount} />
                                    )}
                                  </>
                                )}
                              {localStorage.getItem("token") ? (
                                <li class="htc-nav-item ">
                                  <a
                                    href="javascript:void(0)"
                                    class="htc-nav-link add-to-cart"
                                    data-bs-toggle="modal"
                                    data-bs-target="#chatCollapse"
                                    onClick={(e) => {
                                      e.preventDefault();

                                      navigate("/my-account/watchlist");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_5571_58128)">
                                        <path
                                          d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_5571_58128">
                                          <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    Watchlist
                                    {props?.dashboardCount?.watchListCount > 0 ? (
                                      <span class="cart-numbers">{props?.dashboardCount?.watchListCount}</span>
                                    ) : (
                                      ""
                                    )}
                                  </a>
                                </li>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </ul>
                      </div>
                      <div className={styles.google_translator}>
                        <div id="google_translate_element"></div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            className={`${styles.headerTopContainer} d-flex align-items-center new-brand-common-header d-none d-xl-block`}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 d-flex align-items-center position-relative">
                  <>
                    <div
                      className={
                        typeof window !== "undefined" && localStorage.getItem("token")
                          ? `${styles.htcTextBox}`
                          : `${styles.htcTextBox} `
                      }
                    >
                      <strong>$5.2B Global Marketplace</strong> for Asset Recovery & Surplus Inventory
                    </div>

                    <div className="htc-nav  ms-auto d-none d-xl-block">
                      <ul
                        className="htc-nav-list text-capitalize d-flex align-items-center"
                        style={{ marginRight: "13rem" }}
                      >
                        {typeof window !== "undefined" && (
                          <>
                            {localStorage.getItem("member") && (
                              <li class="htc-nav-item position-relative">
                                <a
                                  href="javascript:void(0)"
                                  class={`${styles.htcNavLink} htc-nav-link add-to-cart`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#chatCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    props?.toggleHelp();
                                  }}
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.09009 9.00008C9.32519 8.33175 9.78924 7.76819 10.4 7.40921C11.0108 7.05024 11.729 6.91902 12.4273 7.03879C13.1255 7.15857 13.7589 7.52161 14.2152 8.06361C14.6714 8.60561 14.9211 9.2916 14.9201 10.0001C14.9201 12.0001 11.9201 13.0001 11.9201 13.0001"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12 17H12.01"
                                      stroke="white"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Help
                                </a>
                              </li>
                            )}
                            {localStorage.getItem("member") &&
                              JSON.parse(localStorage.getItem("member")).sec_list != 100103 && (
                                <>
                                  {window.location.pathname === "/chats" || window.location.pathname === "/chats/" ? (
                                    <li className={` htc-nav-item`}>
                                      <a
                                        href="javascript:void(0)"
                                        className={` htc-nav-link`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#chatCollapse"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          //this.setState({ chatNotification: false });
                                          navigate("/chats");
                                        }}
                                      >
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                        Messages
                                        {props?.unReadChatCount > 0 ? (
                                          <span class="cart-numbers chat-unread">{props?.unReadChatCount}</span>
                                        ) : (
                                          ""
                                        )}
                                      </a>
                                    </li>
                                  ) : (
                                    <ChatIcon unReadChatCount={props?.unReadChatCount} />
                                  )}
                                </>
                              )}
                            {localStorage.getItem("token") ? (
                              <li class="htc-nav-item ">
                                <a
                                  href="javascript:void(0)"
                                  class="htc-nav-link add-to-cart"
                                  data-bs-toggle="modal"
                                  data-bs-target="#chatCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/my-account/watchlist");
                                  }}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_5571_58128)">
                                      <path
                                        d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_5571_58128">
                                        <rect width="20" height="20" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Watchlist
                                  {props?.dashboardCount?.watchListCount > 0 ? (
                                    <span class="cart-numbers">{props?.dashboardCount?.watchListCount}</span>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </li>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </ul>
                    </div>
                    <div className={styles.google_translator}>
                      <div id="google_translate_element"></div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        )
      ) : (
        <>
          {mimic ? (
            <div class={`${styles.headerTextWrapper} text-center d-flex align-items-center`}>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <strong>Currently Logged In as</strong>{" "}
                    {typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"))?.name01}.{" "}
                    <a
                      href=""
                      target="_blank"
                      onClick={(e) => {
                        e.preventDefault();
                        localStorage.removeItem("mimictoken");
                        localStorage.removeItem("mimicmember");
                        window.location.reload();
                      }}
                    >
                      Click here
                    </a>{" "}
                    to login back to your account.
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};
export default CommonHeader;
